import { z } from 'zod';
export const calendlyConnectionResponseSchema = z.object({
    id: z.string().uuid(),
    status: z.enum(['active', 'needs_reconnect', 'disabled']),
    email: z.string(),
    name: z.string().nullable(),
    ownerMembershipId: z.string().uuid(),
    ownerDisplayName: z.string(),
    lastWebhookError: z.string().nullable(),
    lastEventAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=connection.js.map